export default {
  line: "रेखा",
  language: "भाषा",
  common: [
"ऑनलाइन सेवाएँ",
"निलंबन रद्द करें",
"क्या खरीदारी के लिए 10,000 ₽ खर्च करना होगा!"
  ],
  
  charitables:[//慈善
  	  "SGM के आधिकारिक सूचना केंद्र में आपका स्वागत है! 🌟 पारदर्शी और प्रामाणिक जानकारी के लिए आपका मंच। यहाँ, आप हमारे आधिकारिक प्रमाणन प्रमाणपत्रों की जाँच कर सकते हैं 📜, व्यापक जानकारी के लिए www.sgm.top पर जा सकते हैं 🌐, और नवीनतम अपडेट के लिए हमारे Telegram चैनल को फॉलो कर सकते हैं! 📲 इसके अतिरिक्त, आपको याहू, एसोसिएटेड प्रेस और गूगल जैसे अंतरराष्ट्रीय मीडिया से SGM की सकारात्मक समीक्षाएँ भी मिलेंगी! 📰 यह सब SGM ब्रांड और इसके भविष्य के विकास में आपके विश्वास को काफी बढ़ाएगा, जो आपको साझा गतिशीलता व्यवसाय में सफल होने और लगातार पर्याप्त अतिरिक्त आय अर्जित करने में मदद करेगा! 💰🚀"
  	  ],
  details:[
  	  "कार्य इकाई मूल्य",
  	  "ऑर्डर की संख्या्या",
  	  "दैनिक आय",
  	  "स्तर",
  	  "दैनिक लाभ",
  	  "जमा",
  	  "जमा वापसी तिथि",
  	  "शेष दिन",
	  "मेरा एसजीएम स्तर"
  ],
  upload: [
"अपलोड हो रहा है...",
"गलत फ़ॉर्मेट",
"अपलोड सफलतापूर्वक हुआ",
"अपलोड विफल"
  ],
  vanPull: [
"अब और डेटा नहीं",
"कोई डेटा नहीं"
  ],
  login: {
    title:'उपयोगकर्ता नाम और पासवर्ड से लॉगिन करें',
    title_txt:'अपने पंजीकृत मोबाइल फ़ोन नंबर का उपयोग करके लॉग इन करें',
    text: [
"उपयोगकर्ता नाम/पासवर्ड याद रखें",
"लॉगिन हो रहा है...",
"अभी लॉग इन करें"
    ],
    placeholder: [
"कृपया फ़ोन नंबर दर्ज करें",
"कृपया लॉगिन पासवर्ड दर्ज करें"
    ],
    i18n: [
"कोई {title} खाता नहीं? {a} {line}",
"रजिस्टर करें"
    ]
  },
  register: {
    text: [
"पंजीकरण के लिए आपका स्वागत है",
"एसएमएस कोड भेजा जा रहा है...",
"एसएमएस कोड प्राप्त करें",
"पंजीकरण हो रहा है...",
"अभी पंजीकरण करें",
"क्या आपके पास पहले से खाता है? अभी लॉग इन करें",
"मोबाइल फ़ोन नंबर पंजीकरण",
"ईमेल पंजीकरण",
"लॉगिन पर वापस जाएँ",
"कृपया अपंजीकृत फ़ोन नंबर और ईमेल पते का उपयोग करें"
    ],
    placeholder: [
"कृपया अपना फ़ोन नंबर दर्ज करें",
"कृपया SMS सत्यापन कोड दर्ज करें",
"कृपया लॉगिन पासवर्ड दर्ज करें",
"कृपया अपना पासवर्ड पुष्टि करें",
"कृपया आमंत्रण कोड दर्ज करें",
"दो पासवर्ड अलग-अलग हैं",
"कृपया सत्यापन कोड दर्ज करें",
"कृपया ईमेल नंबर दर्ज करें",
"0 से शुरू नहीं हो सकता"
    ],
    i18n: [
"क्या आपके पास खाता है? {a} {line}",
"लॉगिन करें"
    ]
  },
  home: {
    lucky: "यह कार्यक्रम अभी खुला नहीं है",
    map: "जगह",
    qywh: "कॉर्पोरेट संस्कृति",
    broadcast: "एसजीएम ऑनलाइन बाइक-शेयरिंग कार्यक्रम में शामिल होने के लिए एक मित्र को आमंत्रित करने, {vipname} में पदोन्नत होने और {grade} शेयरिंग पुरस्कार प्राप्त करने के लिए {member} को बधाई।",
    menu: [
"वीआईपी क्षेत्र",
"वीडियो ट्यूटोरियल",
"प्रमोशन पुरस्कार"
    ],
    taskHall: {
      title: [
"कार्य कक्ष",
"व्यावसायिक कक्ष",
"लाभ कमाने के लिए कार्य पूरे करें"
      ]
    },
    title:['कार्य','समाचार','अधिक','अनलॉक','कृपया अनलॉक करें और उपयोग जारी रखें~','चेक आउट','बधाई हो!अपग्रेड सफल','बधाई हो~ दो ड्रॉप कार्ड मिले'],
    memberList: {
      title: "सदस्यता सूची",
      data: [
        "{member},आज के {num} ऑर्डर कार्य पूरे करें!"
      ]
    },
    businessList: {
      title: "व्यापारी सूची",
      data: [
        "{member}",
        "आज {num} एकल कार्य जारी करें"
      ]
    },
    noticeTitle: ["सूचना","पिछला","अगला"],
    tabBar: ["होम","वितरण्य","टी", "मानचित्र", "मेरा"],
    msg: "कार्य खुला नहीं है",
    video: "कोई वीडियो ट्यूटोरियल नहीं",
	  message: "आपके पास नई खबर है",
	  bonus:[
'<p>"साइक्लिंग कोड" नकद पुरस्कार (1-200000 रुपये) प्राप्त करने के लिए कोड दर्ज करें</p><p>1. "साइक्लिंग कोड" कंपनी की गतिविधियों के माध्यम से प्राप्त किया जाता है!</p><p>2. कार्य समूह समय-समय पर पासवर्ड जारी करता है! आप कार्य समूह की जानकारी पर रोज़ाना ध्यान दे सकते हैं!</p><p>साइकिल चलायें, साझा अर्थव्यवस्था जीवन का आनंद लें, और आसानी से कोड नकद पुरस्कार प्राप्त करें!</p><p>विवरण के लिए, कृपया "भर्ती प्रबंधक" से संपर्क करें</p>',
'पासवर्ड कंपनी की गतिविधियों के ज़रिए प्राप्त होता है!',
'लाल लिफ़ाफ़ा कोड डालें',
'नकद प्राप्त करें',
'राइड कैश {amount}TJS जीतने पर बधाई',
"राइड कैश"
	]
  },
  vip: {
    title:[
"वीआईपी स्तर",
"कार्यों का दावा करने के लिए अभी सदस्यता लें",
"अल्प विकास"
    ],
    user: {
      title: [
"आपकी पहचान",
"आगंतुक"
      ],
      label: "दैनिक कार्यों",
      value: [
"प्रभावी तिथि",
"एक वर्ष",
"कृपया पहले लॉग इन करें",
"इंटर्नशिप वैधता अवधि",
"जमा वापसी उलटी गिनती",
"स्तर एलपी वैधता उलटी गिनती"
      ],
    },
    list: {
      label: "दैनिक आदेश:{number}",
      button: "अब शामिल हों",
      text: [
"दैनिक लाभ",
"मासिक आय",
"भर्ती पुरस्कार: सभी के लिए",
"मुफ़्त",
"प्रति ऑर्डर",
"रेटिंग आय",
"प्रभावी रिटर्न",
"समाप्ति तिथि",
"वर्ष",
"दिन",
"वैधता अवधि"
      ],
    },
    dialog: [
      "क्या आप निश्चित रूप से खर्च करेंगे? {currency} {amount} बनना {name}?",
      "फिलहाल आप हैं {currname} और नहीं हो सकता {name}",
      "क्या आप निश्चित रूप से खर्च करेंगे? {currency} {amount} नवीनीकरण करने के लिए {name}?",
    ],
    index: ["रद्द करें", "पुष्टि करें"],
    desc: [
'{level} लाभ',
'मूल आय',
'समय',
'डिलीवरी की संख्या',
'आय',
'दैनिक',
'मासिक',
'वार्षिक',
'भर्ती आय',//8
'अधीनस्थ स्तर',
'भर्ती कमीशन अनुपात',
'भर्ती बोनस',
'स्तर 1 अधीनस्थ',
"स्तर 2 अधीनस्थ",
"स्तर 3 अधीनस्थ",
'एक दिन की डिलीवरी पर छूट',
'अधीनस्थ स्तर',
'अधीनस्थ वितरण छूट अनुपात',//17
'डिलीवरी छूट राशि',
'स्तर 1 अधीनस्थ',
'स्तर 2 अधीनस्थ',
'स्तर 3 अधीनस्थ',
'3 दिन',
'डिलीवरी इकाई मूल्य',
'परिवीक्षा अवधि विवरण',//24
      'इंटर्नशिप: कोई खरीदारी आवश्यक नहीं, प्रतिदिन 6 प्लेसमेंट, प्रति प्लेसमेंट 11 रुपये का कमीशन, प्रतिदिन 66 रुपये। 3 दिनों के लिए निःशुल्क परीक्षण।',
      'कार्य आयोग का उदाहरण:',
      '<p>स्तर 1 के सहयोगी जो प्रतिदिन 10,000 TJS मूल्य के राइड ऑर्डर पूरे करते हैं, उन्हें 300 TJS का कमीशन मिलेगा।</p><p>स्तर 2 के सहयोगी जो प्रतिदिन 10,000 TJS मूल्य के राइड ऑर्डर पूरे करते हैं, उन्हें 200 TJS का कमीशन मिलेगा।</p><p>स्तर 3 के सहयोगी जो प्रतिदिन 10,000 TJS मूल्य के राइड ऑर्डर पूरे करते हैं, उन्हें 100 TJS का कमीशन मिलेगा।</p>'
,      'रेफरल बोनस विवरण:',
      '<p>(स्तर 1 अधीनस्थ) आप सीधे A को शामिल होने के लिए आमंत्रित करते हैं, A आपका स्तर 1 अधीनस्थ है।</p><p>(स्तर 2 अधीनस्थ) A, B को शामिल होने के लिए आमंत्रित करता है, B आपका स्तर 2 अधीनस्थ है।</p><p>(स्तर 3 अधीनस्थ) B, C को शामिल होने के लिए आमंत्रित करता है, C आपका स्तर 3 अधीनस्थ है।</p><p>नोट: रेफरल बोनस का दावा केवल व्यक्ति के वर्तमान स्तर के उच्चतम बोनस के लिए किया जा सकता है.</p>',
    ]
  },
  lucky: {
  	default:[
"लकी पेडल",
"शेष ड्रॉ की संख्या:",
"रैफ़ल रिकॉर्ड",
"लॉटरी नियम",
"<p>कंपनी की गतिविधियों में भाग लें और लकी ड्रॉ के अवसर प्राप्त करें!</p>",
"विजेता उपयोगकर्ता रिकॉर्ड",
['बधाई हो: {member}','पुरस्कार प्राप्त करें {profit}'],
"बधाई हो, पुरस्कार प्राप्त करें ",
"बंद करें",
"आपके ड्रॉ का समय समाप्त हो गया है",
"इस तिथि तक मान्य"
  	],
    scattered:[
'ड्रॉ की संख्या',
'सवारी',
'<p>1. ड्रॉ की संख्या कंपनी की गतिविधियों के माध्यम से प्राप्त की जाती है!</p><p>2. प्रत्येक ड्रॉ में 1 ड्रॉ होता है!</p><p>3. भौतिक पुरस्कार जीतने के बाद, कृपया अपनी जानकारी दर्ज करने और इसे प्राप्त करने के लिए भर्ती प्रबंधक से संपर्क करें!</p>',
'अनुस्मारक',
'महत्वपूर्ण अनुस्मारक',
'ड्रा पात्रता',
'कंपनी की गतिविधियों के माध्यम से ड्रॉ के अवसर प्राप्त करें',
'ड्रा नियम',
'प्रति प्रयास 1 ड्रॉ',
'पुरस्कार मोचन',
'भौतिक पुरस्कारों के लिए भर्ती प्रबंधक से संपर्क करें'
    ],
	prizeList:[
		'लकी पेडल प्राइज़ पूल',
		'TJS52 नकद',
		'तुरंत निकासी',
		'TJS88 नकद',
		'TJS205 नकद',
		'TJS19,889 नकद',
		'TJS236,666 नकद',
		'एंड्रॉइड फ़ोन',
		'TJS8,000 मूल्य',
		'अपग्रेड वाउचर',
		'TJS600 मूल्य',
		'दोगुने ऑर्डर',
		'रोज़ाना',
		'एसजीएम कंपनी एक्सक्लूसिव पावर बैंक',
		'TJS1,000 मूल्य',
		'मैकेनिकल बाइक',
		'TJS3,000 मूल्य',
		'ई-मोपेड',
		'TJS80,000 मूल्य',
		'आईफ़ोन 17',
		'TJS160,000 मूल्य'
	],
  },
  moments:[
  	  'दैनिक अपडेट',
  	  'एसजीएम कर्मचारियों के लिए बाइक तैनाती से होने वाली आय, धर्मार्थ गतिविधियों और अद्भुत पलों को साझा करने का आधिकारिक मंच। नकद पुरस्कार (1-200,000 रुपये) में प्रवेश करने के लिए लगातार 3 दिनों तक दैनिक अपडेट करें। प्यार फैलाने और हर सवारी को और अधिक मूल्यवान बनाने में टीम के साथियों के साथ जुड़ें!'
  ],
  charitable:[
  	  'हरित परोपकार पहल',
  	  'एसजीएम परोपकार और जन कल्याण को एक कॉर्पोरेट मिशन मानता है। हम नियमित रूप से निम्न-आय वाले समुदायों, विकलांग लोगों और स्कूलों को आपूर्ति और धन दान करते हैं, और हरित गतिशीलता और पर्यावरणीय परियोजनाओं पर गैर-सरकारी संगठनों के साथ सहयोग करते हैं।',
  	  'हमारे द्वारा तैनात प्रत्येक साझा बाइक एक धर्मार्थ दान का प्रतिनिधित्व करती है, जो शहरों को उत्सर्जन कम करने में मदद करती है, साथ ही गर्मी भी फैलाती है।',
  	  'हम "साइकिलिंग, दान और जीत-जीत" की भावना को कायम रखते हैं और अपने पहियों से आशा की किरण जगाते हैं। हम आपको SGM में शामिल होने, हरित भविष्य के लिए साइकिल चलाने और प्रेम फैलाने के लिए तहे दिल से आमंत्रित करते हैं।',
  	  'हम आपको सामुदायिक धर्मार्थ पहलों में सक्रिय रूप से भाग लेने के लिए प्रोत्साहित करते हैं, तथा साथ मिलकर शहर के हर कोने में प्रेम और हरियाली को पनपने देते हैं।'
    ],
  userLc:{
  	default:[
"साइकिलिंग वेल्थ्धि",
"रिकॉर्ड",
"राशि",
"भंडारण अवधि",
"जमा राशि",
"कृपया जमा राशि दर्ज करें",
"राजस्व",
"सबमिट करें",//7
"कृपया पहले उत्पाद चुनें",
"कृपया जानकारी चुनें",
"लाभ",
"दिन",
"कोई डेटा नहीं",
"खरीद समय",
"स्थिति",
"समाप्ति समय",
"शेष राशि",
"आज की कमाई",
"एक-क्लिक खरीदारी"//18
  	],
    tabs: [
"उत्पाद सूची",
"बचत रिकॉर्डी"
     ],
    tips:'<p>VOISP "वेल्थ एन्हांस" कंपनी का सभी M-स्तर के कर्मचारियों को अपनी आय बढ़ाने के और भी तरीके प्रदान करने का तरीका है। निवेश परियोजनाएँ, PAGE, बैंकों, परिसंपत्ति प्रबंधन कंपनियों आदि द्वारा संयुक्त रूप से शुरू की गई वित्तीय निवेश परियोजनाएँ हैं!</p><p>अल्पकालिक निवेश: स्थिर आय, लचीला चक्र चयन! अल्पकालिक निष्क्रिय धन निवेश के माध्यम से अतिरिक्त आय उत्पन्न कर सकता है! दीर्घकालिक निवेश: उच्च रिटर्न, अच्छी नियमित निवेश बचत विकसित करें, उच्च रिटर्न प्राप्त करें, और संचय के माध्यम से अपने सपनों को साकार करें।!</p>'
  },
  newlist: {
    text: [
"कोई रिकॉर्ड नहीं",
"अपेक्षित आय",
"परिणाम",
"खरीद समय",
"स्थिति",
"समय समाप्ति"
    ],
    placeholder: [
"अब और डेटा नहीं",
"कोई डेटा नहीं"
    ],
    i18n: [
     "खरीदारी का इतिहास",
    ],
	title:[
		"Cycling Wealth हरित बचत योजना — SGM द्वारा अपने स्थायी कर्मचारियों के लिए विशेष रूप से तैयार की गई एक विशेष सुविधा!",
		"RBI जैसे प्रतिष्ठित वित्तीय संस्थानों द्वारा विनियमित और अधिकृत, आपकी धनराशि 100% सुरक्षित है। SGM ने कई अग्रणी बैंकों के साथ मिलकर विभिन्न प्रकार की बचत योजनाएं पेश की हैं, जिनमें लचीली अवधि और विविध लाभ हैं, जो आपके वित्तीय लक्ष्यों के अनुरूप हैं।",
		"हम न केवल आपको साइकिल तैनाती में सक्रिय भागीदारी और कम-कार्बन यात्रा को अपनाने के लिए प्रोत्साहित करते हैं, बल्कि यह भी चाहते हैं कि आप अपने भविष्य के लिए समझदारी से वित्तीय योजना बनाएं। SGM आपके साथ मिलकर हरित संपत्ति का एक नया अध्याय शुरू करने के लिए प्रतिबद्ध है!"
	]
  },
  product: {
    default: [
"प्रमोशन खाता शेष",
"प्रारंभिक बचत राशिि",
"अधिकतम बचत राशि",
"चक्र",
"दैनिक ब्याज दर",
"अधिकतम",
"परियोजना नियम",
"परियोजना राशि",
"भुगतान विधि",
"प्रारंभिक बचत राशि",
"दैनिक लाभ",
"रिलीज़ चक्र",
"अनुमानित आय"
    ],
    placeholder: [
"परिपक्वता पर मूलधन और आय लौटाएँ (छुट्टियों के दिनों में सामान्य)",
", 24 घंटों के भीतर स्वचालित निपटान",
      "{str} = कुल आय {income} {currency} + प्रधानाचार्य {money} {currency} = कुल मूलधन और ब्याज {total} {currency}",
      "सुरक्षा पासवर्ड"
    ]
  },
  user: {
    vipl:"भागीदार स्तर",
    hello:"वापसी पर स्वागत है",
    default: [
"मेरे वरिष्ठ",
"खाता",
"आमंत्रण कोड",
"लॉगिन से बाहर निकलें",
"शेष राशि",
"सोना",
"मेरा वॉलेट",
"सील",
"प्रतिबंध",
"अच्छा",
"उत्कृष्ट",
"'रीडिंग असिस्टेंट' सक्रिय करें",
"नियुक्ति प्रबंधक से संपर्क करें",
"बैंक शुल्क"
    ],
    myEarnings: {
            grid: ["शेष राशि","कल की कमाई","आज की कमाई","इस सप्ताह की कमाई","इस महीने की कमाई","पिछले महीने की कमाई","कुल राजस्व","आज कार्य पूरा करें(PCE)","आज के शेष कार्य(PCE)","आज का कमीशन","डिलीवरी छूट","रेफ़रल छूट"]
        },
    grid: [
"शेष राशि",
"कल की कमाई",
"आज की कमाई",
"इस हफ़्ते की कमाई",
"इस महीने की कमाई",
"पिछले महीने की कमाई",
"कुल आय",
"आज का कार्य पूरा करें (पीसीई)",
"आज के बचे हुए कार्य (पीसीई)",
"आज का कमीशन",
"आज की छूट"
    ],
    menu: [
"कार्य रिकॉर्ड",
"ऑडिट कार्य",
"रिलीज़ प्रबंधन",
"व्यक्तिगत जानकारी",//3
"खाता बाइंडिंग",
"दैनिक विवरण",
"लेखा रिकॉर्ड",//6
"साझा आमंत्रण",
"टीम रिपोर्ट",//8
"सहायता पुस्तिका",//9
"क्रेडिट स्कोर",//10
"ऐप डाउनलोड करें",//11
"लकी पेडल",//12
"साइक्लिंग वेल्थ",
"रीडिंग असिस्टेंट",
"कॉर्पोरेट संस्कृति",
"वीडियो निर्देश",
"उत्कृष्ट टीम",
"साइक्लिंग वेल्थ",
"SGM का अनुसरण करें",
"विकास पुरस्कार",
"साइक्लिंग कोड",
"डीड्स पेडल"
    ],
	positions:[
"मेरा पद",
"वर्तमान पद",
"अगला पद",
"सीधे संबद्ध एम-स्तर सदस्य",
"स्तर 3 टीम एम सदस्य",
"स्तर 3 टीम ({post} की संख्या)",
"अपने पद को आगे बढ़ाने के लिए नियुक्ति प्रबंधक से संपर्क करने हेतु सभी आवश्यकताएँ पूरी करें!",
"पद का विवरण",
"पद के लिए आवेदन करें",
"पद की जानकारी"
	],
	office:[
"मेरी नौकरी की जानकारीी",
"नौकरी में पदोन्नति का विवरण",
"एसजीएम नौकरी विवरण",
"कॉर्पोरेट पद",
"नौकरी में पदोन्नति",
"अपना आवेदन जमा करें",
"पदोन्नति की प्रगति",
"कम से कम ",
"शर्तें पूरी नहीं हुईं",//8
"तीन-स्तरीय टीम (1/2/3) के सदस्यों को ({name}) बनना होगा।",
"टीम में ",
" से ज़्यादा सदस्य होने चाहिए",
"प्राप्त किया गया"//12
	],
	current:[
"वर्तमान पद",
"वीआईपी कुल सदस्य"
	],
	subordinate:[
"1-लेवल",
"2-लेवल",
"3-लेवल",
"सदस्य सूची",
"कुल लोग",
"कुल राजस्व",
"निकासी राशि",
"टीम आय",
"सदस्य सूची",
"उपयोगकर्ता",
"स्तर",
"जुड़ने का समय",
"परीक्षण अवधि"
	],
	follow:[
"SGM आधिकारिक चैनल",
"SGM की नवीनतम जानकारी के लिए चैनल को फ़ॉलो करें!"
	]
  },
  userInfo: {
    default: [
"व्यक्तिगत जानकारी",
"सिर का चित्र",
"मोबाइल नंबर",
"बैंक खाता जोड़ें",
"Alipay",
"असली नाम",
"लॉगिन पासवर्ड",
"फ़ंड पासवर्ड",
"सेटिंग्स पर क्लिक करें",
"सिर का चित्र बदलें",
"लॉगिन पासवर्ड बदलें",
"फ़ंड पासवर्ड बदलें",
"सबमिट करें",
"कैश खाली करें",
"साइन आउट करें"
    ],
    label: [
"मूल लॉगिन पासवर्ड",
"नया लॉगिन पासवर्ड",
"पासवर्ड की पुष्टि",
"मूल मनी कोड",
"नया मनी कोड",
"पासवर्ड की पुष्टि"
    ],
    placeholder: [
"कृपया मूल लॉगिन पासवर्ड दर्ज करें",
"कृपया नया लॉगिन पासवर्ड दर्ज करें",
"कृपया लॉगिन पासवर्ड की पुष्टि करें",
"कृपया मूल फंड पासवर्ड दर्ज करें",
"कृपया नया फंड पासवर्ड दर्ज करें",
"कृपया फंड पासवर्ड की पुष्टि करें"
    ]
  },
  userSet: {
    default: [
"असली नाम प्रमाणीकरण",
"विस्तृत जानकारी",
"अलीपे से लिंक करें",
"सबमिट करें"
    ],
    label: [
"असली नाम",
"QQ",
"Alipay खाता",
"Alipay नाम"
    ],
    placeholder: [
"कृपया अपना असली नाम दर्ज करें (नकद निकासी के लिए मेरा नाम इस्तेमाल किया जाता है)",
"QQ नंबर दर्ज करें",
"कृपया Alipay खाता दर्ज करें",
"कृपया Alipay नाम दर्ज करें"
    ],
    tips: "अनुस्मारक: बाध्य बैंक कार्ड को संशोधित नहीं किया जा सकता है, इसका उपयोग आपकी निकासी के लिए किया जाता है"
  },
  bindAccount: {
    default: [
"खाता बाइंड करें",
"ट्यूटोरियल देखें",
"सबमिट करें"
    ],
    tabs: [
"खाता",
"खाता",
"खाता"
    ],
    label: [
"निर्देश",
"स्क्रीनशॉट जोड़ें",
"खाता"
    ],
    placeholder: "कृपया अपना {account} खाता दर्ज करें"
  },
  bankCard: {
    default: [
"बैंक कार्ड बाँधें",
"अभी प्रमाणित करें",
"सबमिट किया जा रहा है...",
"अभी जोड़ें",
"बैंक कार्ड जोड़ें",

    ],
    tips: [
      "कृपया बैंक कार्ड जोड़ने से पहले वास्तविक नाम प्रमाणीकरण पूरा करें",
      "आपके बैंक कार्ड पर खाता नाम आपके द्वारा प्रमाणित वास्तविक नाम के अनुरूप होना चाहिए, अन्यथा आप सफलतापूर्वक नकदी नहीं निकाल पाएंगे."
    ],
    label: [
"नाम",
"बैंक का नाम",
"बैंक खाता संख्या",
"शाखा कोड",
"IFSC"
    ],
    placeholder: [
"कृपया बैंक का नाम चुनें",
"कृपया बैंक खाता संख्या दर्ज करें",
"कृपया शाखा कोड दर्ज करें",
"पुष्टि करें",
"रद्द करें"	,
"कृपया IFSC दर्ज करें"
    ]
  },
  wallet: {
    default: [
"मेरा वॉलेट",
"रिचार्ज",
"निकासी",
"रिचार्ज रिकॉर्ड",
"निकासी रिकॉर्ड",
"R",
"W",
"₽ रिचार्ज"
    ],
    label: [
"निकासी विधि",
"निकासी राशि",
"फंड पासवर्ड",
"सबमिट करें",
"फ़ोन नंबर",
"ईमेल",
"IFSC",
"भुगतान विधि",
"कराधान",
"वास्तविक प्राप्त राशि"
    ],
    placeholder: [
"निकासी विधि चुनें",
"कृपया निकासी राशि दर्ज करें",
"कृपया फंड पासवर्ड दर्ज करें",
"कृपया निकासी विधि चुनें",
"कृपया प्राप्तकर्ता का मोबाइल फ़ोन नंबर दर्ज करें",
"कृपया प्राप्तकर्ता का ईमेल पता दर्ज करें",
"कृपया प्राप्तकर्ता का IFSC कोड दर्ज करें",
"कृपया भुगतान विधि चुनें"
    ],
    msg: [
"आपने अभी तक फ़ंड पासवर्ड सेट नहीं किया है, कृपया पहले सेट करें",
"आपने अभी तक अपना बैंक कार्ड लिंक नहीं किया है, कृपया पहले उसे लिंक करें",
"<p>निकासी का समय:</p><p>सोमवार: M9</p><p>मंगलवार: M8</p><p>बुधवार: M6/M7</p><p>गुरुवार: M3/M4/M5</p><p>शुक्रवार: M1/M2</p><p>(इंटर्नशिप सोमवार से रविवार तक)</p><p>सुबह 9 बजे से शाम 6 बजे तक</p>"
    ]
  },
  recharge: {
    default: [
"रिचार्ज",
"रिचार्ज विवरण",
"रिचार्ज रिकॉर्ड",
      "उपलब्ध शेष राशि {money}, कृपया रिचार्ज विधि चुनें",
      "एकल न्यूनतम राशि है {currency} {min}, अधिकतम {currency} {max}, संचालन शुल्क {fee}%",
"सबमिट हो रहा है...",
"अभी रीचार्ज करें",
"वापस करें",
"लोड हो रहा है...",
	  "एकल न्यूनतम राशि है ${min}, अधिकतम ${max}, संचालन शुल्क {fee}%"
    ],
    label: [
"रिचार्ज राशि",
"रिचार्ज चैनल",
"ट्रांसफर का नाम",
"भुगतानकर्ता का नाम",
"भुगतानकर्ता का मोबाइल फ़ोन",
"भुगतानकर्ता का UPI खाता",
"भुगतानकर्ता का ईमेल",
"लेनदेन आदेश"
    ],
    placeholder: [
"कृपया रीचार्ज राशि दर्ज करें",
"कृपया रीचार्ज चैनल चुनें",
"कृपया ट्रांसफ़र का नाम दर्ज करें",
"एकल न्यूनतम राशि {currency} {min} है",
"एकल अधिकतम राशि {currency} {max} है",
"कृपया भुगतानकर्ता का नाम दर्ज करें",
"कृपया भुगतानकर्ता का मोबाइल फ़ोन नंबर दर्ज करें",
"कृपया भुगतानकर्ता का UPI खाता दर्ज करें",
"कृपया भुगतानकर्ता का ईमेल पता दर्ज करें",
"कृपया ट्रांसफ़र का स्क्रीनशॉट अपलोड करें",
"कृपया ट्रांज़ैक्शन ऑर्डर नंबर दर्ज करें"
    ],
    info: [
"रिचार्ज राशि",
"ऑर्डर संख्या",
"बैंक",
"खाता संख्या",
"नाम",
"कॉपी",
"{type} ट्रांसफ़र",
"ट्रांसफ़र स्क्रीनशॉट",
"सबमिट करें",
"IFSC कोड",
"खाता प्रकार",
"प्रसंस्करण निर्देश"
    ],
    tips: [
"वित्तीय जाँच में देरी से बचने के लिए, कृपया मिलान राशि स्थानांतरित करने के लिए निम्नलिखित विधि चुनें।<br>स्थानांतरण के बाद, कृपया सत्यापन प्रमाणपत्र के रूप में स्थानांतरण स्क्रीनशॉट अपलोड करें",
"दोस्तों को जोड़ने की आवश्यकता नहीं है, मुझे धनराशि स्थानांतरित करने के लिए QR कोड स्कैन करें",
"कृपया नीचे दी गई जानकारी के अनुसार स्थानांतरण पूरा करें",
"संकेत: सफल भुगतान के बाद, कृपया अपना सदस्य खाता संख्या, रिचार्ज राशि, ऑर्डर संख्या, जमाकर्ता खाता संख्या, रिचार्ज समय प्रदान करने के लिए ऑनलाइन सेवा से संपर्क करें, ताकि वित्तीय विभाग समय पर आपके लिए धनराशि जोड़ सके।",
"नोट: कृपया प्रत्येक स्थानांतरण के लिए एक भुगतान जमा करें",
"स्थानांतरण के बाद, कृपया सत्यापन प्रमाणपत्र के रूप में स्थानांतरण स्क्रीनशॉट अपलोड करें",
"सुझाव: भुगतान सफल होने के बाद, कृपया सफल लेनदेन की एक तस्वीर अपलोड करें",
"<p>चार्ज रिमाइंडर: रिचार्ज करने से पहले कृपया पढ़े।</p><p>1: कृपया नवीनतम रिचार्ज खाते के अनुसार भुगतान करें।</p><p>2: भुगतान वैधता अवधि 10 मिनट है। कृपया 10 मिनट के भीतर भुगतान पूरा करें। यदि 10 मिनट के बाद भुगतान नहीं किया जाता है, तो प्राप्त करने वाला खाता अमान्य हो जाएगा। कृपया भुगतान के लिए नवीनतम रिचार्ज खाता पुनः प्राप्त करें।</p><p>3: हस्तांतरण राशि आपके द्वारा जमा की गई राशि के अनुरूप होनी चाहिए।</p><p>4: यदि भुगतान विफल हो जाता है, तो कृपया पिछले प्राप्त करने वाले खाते को सेव न करें। कृपया नवीनतम खाता प्राप्त करने के लिए रिचार्ज ऑर्डर पुनः सबमिट करें, अन्यथा आपका भुगतान अमान्य माना जाएगा।</p><p>5: यदि भुगतान सफल होता है, तो कृपया वित्त विभाग द्वारा समय पर सत्यापन की सुविधा के लिए आवश्यक यूटीआर जमा करें।</p>"
    ]
  },
  postTask:[
"शीर्षक",
"चित्र चुनें",
"वितरित करें",
"कृपया कार्य के लिए एक शीर्षक दर्ज करें"
  ],
  task: {
    default: [
"डिलीवरी सूची",
"कार्य आवश्यकताएँ",
"बनाएँ",
"ऑडिट करें",
"लिंक खोलें",
"लिंक कॉपी करें",
"इकाई मूल्य",
"सबमिट करें",
"छूट",
"सेवा शुरू करें",
"प्रगति पर",
"तैनाती शुरू करें"
    ],
    tabs: [
"कर रहा हूँ",
"ऑडिट",
"पूरा हुआ",
"असफल",
"दुर्भावनापूर्ण",
"छोड़ दिया गया"
    ],
    msg: "आज का मिशन पूरा हो गया है",
    msgSc: "सफलतापूर्वक प्राप्त हुआ",
    msgTime: "उलटी गिनती समाप्त होने के बाद, कार्य स्वचालित रूप से पूरा हो जाएगा और इसे समय से पहले बंद करना अमान्य होगा!",
    info: [
"कार्य विवरण",
"कार्य शीर्षक",
"कार्य लाभ",
"कार्य विवरण",
"अपलोड आवश्यकताएँ",
"नमूना सबमिट करें",
"उपयोगकर्ता ने नमूना सबमिट नहीं किया",
"ऑडिट नोट्स",
"ऑडिट की तिथि",
"मांग पक्ष",
"रिलीज़",
"कॉपी",
"जंप",
"कार्य चरण",
"चरण {index}",
"ऑडिट नमूना",
"कोई ऑडिट नमूना नहीं",
"डेटा लोड हो रहा है...",
"कार्य छोड़ दें",
"पूर्ण कार्य सबमिट करें",
"सामग्री प्रकाशित करें"
    ],
    index: [
"वर्तमान स्थिति",
"आपकी वर्तमान रेटिंग <i style=\"color:#1989fa\">{currVip}</i> है।<br>केवल वर्तमान <i style=\"color:#1989fa\">{currVip}</i> स्तर के कार्य का दावा कर सकते हैं।<br>क्या आप <i style=\"color:#dd6161\">{vip}</i> स्तर में शामिल होना चाहते हैं?",
"अभी शामिल हों",
"कृपया कार्य श्रेणी चुनें",
"रद्द करें",
"शेष",
"नि: शुल्क डिलिवरी",
"अल्प विकास"
    ],
    list: [
"कार्य सूची",
"मांग पक्ष",
"शेष",
"अनुरोध",
"प्राप्ति"
    ],
    show: [
"कार्य विवरण",
"खरीद समय",
"डिलीवरी स्थिति",
"किराया मूल्य",
"डिलीवरी समय",
"प्राप्ति के लिए उलटी गिनती",
"सेवा शुरू करें",
"कोडिंग",
"अनकोन"
    ]
  },
  postRecord: [
"दैनिक अपडेट",
"रिलीज़",
"कुल",
"पूर्ण",
"समय सीमा",
"ऑडिट",
"निरस्तीकरण",
"संपादक",
"दैनिक अपडेट",
"प्राप्त करें",
"SGM घोषणा केंद्र",
"सूचना केंद्र"
  ],
  dayReport: [
"दैनिक विवरण",
"कुल राजस्व",
"मेरा कमीशन",
"मेरे कमीशन लाभ",
"अधीनस्थों द्वारा वितरण पूरा किया गया",
"अधीनस्थ कार्य लाभ",
"पीसीई",
"पिछले 30 दिन",
"मात्रा",
"कार्य",
"अधीनस्थ",
"उपभोग",
"दिनांक"
  ],
  fundRecord: {
    default: [
"व्यय रिकॉर्ड",
"पुनर्भरण रिकॉर्ड",
"राजस्व रिकॉर्ड",
"आर",
"आई",
"ई",
"निकासी रिकॉर्ड",
    ],
    tabs: [
"राजस्व",
"व्यय",
"पुनर्भरण",
"निकासी"
    ],
	state: [
		'सभी',
		'फिर से दाम लगाना',	//1 recharge
		'निकासी',	//2 withdrawal
		'कार्य पोस्ट करें',	//3 task
		'प्लैट पंप',	//4 pump
		'छूट',	//5 rebate
		'डिलीवरी पूरी हो गई',	//6 commission
		'गतिविधि पुरस्कार',	//7 regment
		'रेफरल पुरस्कार',	//8 spread
		'उन्नत करना',	//9 buymembers
		'कार्य रद्द करें',	//10 revoke
		'निवेश आय',	//11 transfer_c
		'निवेश में स्थानांतरण',	//12 transfer_r
		'अन्य राजस्व', //13 其他
		'दान करें',	//14
		'लाल लिफाफा',	//15
		'स्मार्ट रोबोट खरीदें',//16
		'भाग्यशाली पेडल',//17
		'वीआईपी खरीद वापसीी',//18
	]
  },
  promote: [
"आपका सबसे अच्छा दोस्त",
"आपको {title} में शामिल होने के लिए आमंत्रित करता/करती हूँ",
"रेफ़रल कोड",
"सिफारिश कोड कॉपी करें",
"आमंत्रण लिंक कॉपी करें",
"QR कोड सेव करें",
"प्रचार प्रोत्साहन",
"पोस्टर सफलतापूर्वक सेव करें",//7
"पोस्टर सेव नहीं हो सका, कृपया कुछ और बार कोशिश करें या स्क्रीनशॉट सेव करें",
"कृपया स्क्रीनशॉट लें",
"प्रचार पोस्टर सेव करें",
"प्रचार पोस्टर को अपने फ़ोन में सेव करें<br>अगर आप असफल होते हैं, तो कृपया कुछ और बार कोशिश करें या स्क्रीनशॉट सेव करें",
"केवल एसजीएम वीआईपी आधिकारिक उपयोगकर्ता ही मित्रों को शामिल होने के लिए आमंत्रित करने के पात्र हैं!",
"साझा आमंत्रणें",
'<p>1. साझा बोनस: साझा बोनस अर्जित करने के लिए नए उपयोगकर्ताओं को SGM में आमंत्रित करें।</p><p>2. टीम कमीशन: आप अपने अधीनस्थों के साइकिल संचालन से प्रतिदिन कमीशन कमा सकते हैं।</p><p>3. कंपनी के कार्यक्रम: कंपनी समय-समय पर "लकी पेडल", "साइक्लिंग कोड" और भौतिक पुरस्कारों सहित विभिन्न प्रचार कार्यक्रम शुरू करती है।</p><p>4. संचित पुरस्कार: प्लेटफ़ॉर्म के होमपेज पर एक निश्चित नकद पुरस्कार प्राप्त करने के लिए एक निश्चित संख्या में मित्रों को आमंत्रित करें। आप जितने अधिक आमंत्रित करेंगे, पुरस्कार उतना ही अधिक होगा।</p><p>5. कंपनी के पद: एक बार जब आपकी टीम एक निश्चित आकार तक पहुँच जाती है, तो आप कंपनी के भीतर और अधिक पदों के लिए आवेदन कर सकते हैं, जैसे कि प्रवेश-स्तर, मध्य-स्तर, वरिष्ठ और प्रबंधक विपणन पद, और अतिरिक्त मासिक वेतन प्राप्त कर सकते हैं।</p><p style=\"font-weight: bolder\">हर बाइक वित्तीय आज़ादी की ओर एक कदम है; हर सवारी शहरी उत्सर्जन को कम करने में योगदान देती है। एसजीएम आपको वित्तीय आज़ादी और एक पर्यावरण-अनुकूल जीवनशैली, दोनों हासिल करने में मदद करता है।</p>',
"टीम साझा यात्रा"
  ],
  teamReport: {
    default: [
"खोजें",
"टीम बैलेंस",
"टीम लाभ",
"टीम रिचार्ज",
"टीम निकासी",
"पहले चार्ज की संख्या",
"पहले पुश की संख्या",
"टीम का आकार",
"नई टीम",
"पीसीई",
"मैं",
"उपयोगकर्ता",
"रिचार्ज",
"निकासी",
"छूट",
"कमीशन",
"तारीख चुनें",
"कोई डेटा नहीं",
"निकासी राशि",
"निकासी संख्या",
"निकासी छूट",
"टीम निकासी की संख्या",//21
"टीम पार्टनर",
"अनुशंसित कुल आय",
"डिलीवरी छूट से कुल राजस्व",
"स्तर 3 टीम की कुल निकासी",
"ग्रेड",
"अभिभावक",
"आमंत्रित व्यक्ति",
"सदस्य सूची",
"कुल सदस्य"
    ],
    tabs: [
"टीम रिपोर्ट",
"मेरी टीम"
    ],
    team: [
"स्तर 1",
"स्तर 2",
"स्तर 3"
    ]
  },
  help: [
"सहायता मैनुअल",
"उपलब्ध नहीं है"
  ],
  message:[
"संदेश देखें",
"कोई संदेश नहीं"
  ],
  credit: [
"क्रेडिट स्कोर",
"क्रेडिट नोट",
"क्रेडिट रिकॉर्ड",
"<p>प्रारंभिक क्रेडिट स्कोर 60 अंक है।</p><p>1: यदि अंक 50 से कम हैं, तो दैनिक डिलीवरी मात्रा आधी हो जाएगी।</p><p>2: स्कोर 30 अंक से कम है और दैनिक वितरण कार्य पूरा नहीं किया जा सकता है।</p><p>3: यदि स्कोर 10 अंक से कम है, तो आप नकद निकासी के लिए आवेदन नहीं कर सकेंगे।</p><p>पॉइंट रिवॉर्ड नियम: कार्य स्तर को अपग्रेड करने पर 5 अंक जुड़ेंगे, और अधीनस्थों को (औपचारिक कर्मचारी) बनने के लिए आमंत्रित करने पर 1 अंक जुड़ेगा।</p><p>नकारात्मक कार्य रवैया, समय पर डिलीवरी पूरी न कर पाना और कंपनी के नियमों का उल्लंघन किसी के क्रेडिट स्कोर को प्रभावित करेगा।</p>",
"मेरा क्रेडिट",
"फिलहाल कोई क्रेडिट रिकॉर्ड नहीं है"
  ],
  dialog: [
"सुझाव",
"पुष्टि करें",
"सबमिट हो रहा है...",
"कॉपी सफल रही",
"IOS सिस्टम संस्करण कम है और समर्थित नहीं है",
"पंजीकरण हो रहा है...",
"डेटा लोड हो रहा है..."
  ],
  lineList: [
"लाइन चयन",
"वर्तमान लाइन",
"लाइन"
  ],
  serviceCenter: [
"ग्राहक सेवा",
"नमस्ते, विशेष ग्राहक सेवा",
"आपकी सेवा करके खुशी हुई।",
"स्वयं सेवा",
"ऑनलाइन ग्राहक सेवा",
"रिचार्ज ग्राहक सेवा",
"लाइन ग्राहक सेवा"
  ],
  direct:[
'SGM',
'विकास बोनस',
'गतिविधि विवरण',
'<p>सदस्यों को सीधे VIP स्तर में शामिल होने के लिए आमंत्रित करने के बाद, यदि आप शर्तें पूरी करते हैं तो आप नकद पुरस्कार प्राप्त कर सकते हैं!</p><p>उदाहरण के लिए: यदि आप कुल मिलाकर 3 VIP-स्तर के सदस्यों को आमंत्रित करते हैं, तो आप सीधे पुरस्कार प्राप्त कर सकते हैं। इसे प्राप्त करने के बाद, अन्य लक्ष्यों को प्राप्त करना जारी रखें और इसे प्राप्त करना जारी रखें।</p><p>SGM विशेष विकास पुरस्कार, प्रत्येक पुरस्कार प्रत्येक कर्मचारी द्वारा केवल एक बार प्राप्त किया जा सकता है।</p>',
'अधीनस्थों की संख्या',
'समाप्त किया जाना है',
'आमंत्रण लाभ',
'पुरस्कार प्राप्त करें',
'प्राप्त'
  ],
  activity:[
'डीड्स पेडल',
'विवरण',
'दान करें',
'खाते में शेष राशि',
'सभी',
'भुगतान करें',
'कृपया दान राशि दर्ज करें',
'आपके दान के लिए धन्यवाद'
  ],
  apply: {
    awardsTitle: "Awards",
    awardsContent: "Awards",
    pickUpVehicles: "{count} वाहन लें"
  },
  positions:{
    info:['पद विवरण','पद आवेदन','पद','स्तर 3 टीम जी-स्तर नियमित कर्मचारी','तृतीय-स्तरीय टीम सदस्यों का अनुपात','इस माह का वेतन', 'वेतन निपटान', 'पूर्ण', 'पूर्ण किया जाना है', 'प्राप्त','वेतन संग्रहण समय'],
    job: ['समीक्षा के लिए सबमिट करें','समीक्षा अधीन','समीक्षा की गई','कृपया अपने प्रासंगिक दस्तावेज़ अपलोड करें','टिप्पणियाँ','अपना पहचान पत्र फ़ोटो चुनने और अपलोड करने के लिए चित्र पर क्लिक करें।','कृपया फ़ोटो A में अपने पहचान पत्र के सामने वाले भाग की फ़ोटो अपलोड करें।','कृपया फ़ोटो B में अपने पहचान पत्र के पीछे वाले भाग की फ़ोटो अपलोड करें।','कृपया फ़ोटो C में अपना पहचान पत्र पकड़े हुए अपनी फ़ोटो अपलोड करें।','फ़ोटो A','फ़ोटो B','फ़ोटो C','कृपया वह पद चुनें जिस पर आप पदोन्नत होना चाहते हैं','पद','मूल वेतन','अतिरिक्त बोनस','कर्मचारियों के लिए सूचना','मैंने 《पद आवेदन दिशानिर्देश》 की सामग्री पढ़ ली है और उससे सहमत हूँ','पद आवेदन सबमिट करें',"कृपया एक पद चुनें","कृपया फ़ोटो A चुनें","कृपया फ़ोटो B चुनें","कृपया फ़ोटो C चुनें"]
  },
}